import { Table } from "ant-design-vue";
import NewTable from "./src/YwTable.vue";
import "./src/table.less"
const { Column, ColumnGroup, ...other } = Table;
const YwTable = {
	...other,
	name: "YwTable",
	Column: {
		...Column,
		name: "YwColumn",
	},
	ColumnGroup: {
		...ColumnGroup,
		name: "YwColumnGroup",
	},
};

YwTable.install = function (Vue) {
	Vue.use(Table);
	Vue.component(YwTable.name, NewTable);
	Vue.component(YwTable.Column.name, YwTable.Column);
	Vue.component(YwTable.ColumnGroup.name, YwTable.ColumnGroup);
};
export default YwTable;
